export default {
  partner: null,
  partnerActivity: null,
}
